<template>
  <div>
    <v-row class="d-flex">
      <v-col cols="4" class="pt-0 pb-0">
        <source-filter store="newsRadar" :exclude="externalSources" />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <site-filter
          store="newsRadar"
          :multiple="false"
          :dependsOnSiteGroups="false"
          siteListGetter="common/getAccessibleSiteList"
        />
      </v-col>
      <v-col cols="4" class="pt-0 pb-0">
        <date-filter store="newsRadar" periodType="past-and-today" />
      </v-col>
    </v-row>
    <v-row class="d-flex">
      <v-col cols="12" class="pt-0 pb-0">
        <origin-filter :site="site" :sources="sources" :dates="dates" />
      </v-col>
    </v-row>
    <v-row class="d-flex">
      <v-col cols="4" class="pt-0 pb-0">
        <config-filter :site="site" store="newsRadar" />
      </v-col>
      <v-col v-if="$can('read', 'ai_factory')" cols="4" class="pt-0 pb-0">
        <aif-auto-config-filter :site="site" />
      </v-col>
      <v-col cols="2" class="pt-0 pb-0">
        <score-filter store="newsRadar" :clearable="true" />
      </v-col>
      <v-col cols="2" class="d-flex pt-0 pb-0">
        <v-spacer />
        <apply-filters :disabled="isLoading" outlined color="secondary" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";

import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter.vue";
import SiteFilter from "@/components/common/filters/SiteFilter.vue";
import AifAutoConfigFilter from "@/components/news-radar/common/filters/AifAutoConfigFilter.vue";
import ConfigFilter from "@/components/news-radar/common/filters/ConfigFilter.vue";
import ScoreFilter from "@/components/ai-factory/common/filters/ScoreFilter.vue";
import SourceFilter from "@/components/news-radar/common/filters/SourceFilter.vue";
import OriginFilter from "@/components/news-radar/common/filters/OriginFilter.vue";

import useAxios from "@/hooks/useAxios";
import useProxy from "@/hooks/useProxy";
import { NEWS_RADAR_EXTERNAL_SOURCES } from "@/utils/constants";

export default {
  name: "Filters",
  components: {
    AifAutoConfigFilter,
    ApplyFilters,
    ConfigFilter,
    DateFilter,
    OriginFilter,
    ScoreFilter,
    SiteFilter,
    SourceFilter,
  },
  setup(props, { emit }) {
    const { isLoading } = useAxios();
    const { store } = useProxy();

    // =>  METHODS

    // =>  COMPUTED
    const site = computed(() => {
      const value = store.getters["newsRadar/getSites"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });
    const sources = computed(() => {
      const value = store.getters["newsRadar/getSources"];

      return (isArray(value) && isEmpty(value)) || value === "" ? 0 : value;
    });
    const dates = computed(() => store.getters["newsRadar/getDates"]);

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      dates,
      externalSources: NEWS_RADAR_EXTERNAL_SOURCES,
      isLoading,
      site,
      sources,
    };
  },
};
</script>

<style></style>
